import React from 'react'
import { Modal, Button, Divider } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import 'react-quill/dist/quill.snow.css'; // ES6
import TextEditor from '../../../../common/TextEditor';


var moment = require('moment');
class CompletedActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: ''
        }

    }

    close = () => {
        this.setState({ comment: '' });
        this.props.closedInitiativeClicked(false, null);
    }

    closedInitiative = () => {
        const { history } = this.props;

        let initaitiveLogsPayload = {
            comment: this.state.comment,
            accountUserId: this.props.user._id,
            commentDate: moment()
        }
        this.props.selectedDataById.id = this.props.selectedDataById._id;
        (this.props.selectedDataById.initativeLogs).unshift(initaitiveLogsPayload)
        dispatch.initiatives.updateInitiativeBySpecificFields({ _id: this.props.selectedDataById._id, initativeLogs: this.props.selectedDataById.initativeLogs, status: this.props.labelType === "cancel" ? 5 : 3 })
        // dispatch.initiatives.updateInitiativeList({ _id: this.props.selectedDataByIdById._id, data: { name: e.target.value, slug: e.target.value.toLowerCase() } })
        this.props.selectedDataById.initativeLogs[0].accountUserId = this.props.user;

        let payload = {}
        payload.organizationId = this.props.selectedOrganisation.id
        dispatch.initiatives.getinitiativesCount(payload);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);

        // The update the status of card with respective to listing
        let pload = {};
        pload.organizationId = this.props.selectedOrganisation.id;
        pload.accountId = this.props.selectedAccount._id;
        dispatch.initiatives.getInitiatives(pload);    //KLM-9338
        let status=this.props.history.location.pathname;
        let label=status.split('/')
        let setLabel=label[6]
        // let setLabel = this.props.labelType === "cancel" ? "cancelled" : "closed"
        history.push('/app/' + this.props.selectedAccount._id + '/_ws/' + this.props.selectedOrganisation.id + '/_in/' + setLabel);
        this.close();
        dispatch.initiatives.getInitiatives(pload);
    }



    updateText = (data, name) => {
        if (name === "Comment") {
            if (data.replace(/<(.|\n)*?>/g, '').trim().length === 0) {
                this.setState({ comment: '' })
            } else {
                this.setState({ comment: data })
            }
        }
    }

    render() {
        return (
            <Modal
                className="basicModal"
                open={this.props.open}
                size='tiny'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>{this.props.labelType === "cancel" ? "Cancel " : "Close "} Initiative</Modal.Header>

                <Modal.Content>
                    <h2 style={{ background: "#F4F8FB", padding: '5px' }}>{this.props.selectedDataById.name}</h2>
                    <Divider />
                    <p> Are you sure you want to {this.props.labelType === "cancel" ? "Cancel " : "Close "}  this Initiative?</p>
                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="issue"
                        id="issueid"
                        onValidSubmit={() => { this.closedInitiative() }}
                    >

                        <TextEditor
                            name="Comment"
                            text={this.state.comment}
                            type="textarea"
                            onChangeText={this.updateText}
                            requiredValue={true}
                        />

                        <div className="pull-right" style={{ "marginBottom": "25px" }}>
                            <Button content='Cancel' className="button-cancel" onClick={this.close} />
                            <Button type="submit" content={this.props.labelType === "cancel" ? "Cancel Initiative" : "Close Initiative"} disabled={this.state.comment.length === 0} className="button-submit" />

                        </div>
                        <br />
                    </Form >
                </Modal.Content>

            </Modal>

        )
    }
}
export default CompletedActivity;